<template>
  <Layout>
  <div class="row">
    <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between icon-main-page">
          <div class="page-title-left avatar-main-icon">
            <div class="avatar-xs mr-3">
              <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                <i class="bx bx-store"></i>
              </span>
            </div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">{{ restaurant && restaurant.name || '' }}</h4>
              <p><router-link :to="{ name: 'vendor-list'}">{{ trans.trans('__JSON__.Vendor',{ vendor: $auth.setting.restaurant_name }) }}</router-link> > {{ restaurant && restaurant.name || '' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="nav-tabs-main">
        <div class="card">
          <div class="card-body">
            <!-- Tab panel start-->
            <b-tabs
              justified
              nav-class="nav-tabs-custom mt-3 order-tabs"
              content-class="p-3 text-muted"
            >
              <b-tab active lazy>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{ trans.get('__JSON__.Profile') }}</span>
                </template>
                <vendor-profile v-if="!!restaurant" :rest_data="restaurant" />
              </b-tab>
              <!-- <b-tab lazy>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-clock"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{ trans.get('__JSON__.Operation Time') }}</span>
                </template>
                <operation-time v-if="!!restaurant" :restaurant="restaurant"/>
              </b-tab> -->
              <b-tab lazy v-if="$auth.hasPermission(config.permissions.merchant_write)">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-lock"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{ trans.get('__JSON__.Change Password') }}</span>
                </template>
              <change-password v-if="!!restaurant" :rest_data="restaurant"/>
              </b-tab>
              <b-tab lazy v-if="$auth.hasPermission(config.permissions.merchant_write)">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-lock"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{ trans.get('__JSON__.Parking Place') }}</span>
                </template>
              <parkingPlace v-if="!!restaurant" :rest_data="restaurant"/>
              </b-tab>
            </b-tabs>
            <!-- Tab panel end -->
          </div>
        </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

import vendorProfile from "./vendor-profile";
import { vendorService } from "../../services";
import changePassword from "./change-password";
import parkingPlace from "./parking_place";
import OperationTime from "./operation-time";
import config from '../../config';

/**
 * Tabs & accordions component
 */
export default {
  components: { Layout, PageHeader,vendorProfile, parkingPlace,changePassword, OperationTime},
  data() {
    return {
      restaurant_id: "",
      restaurant: null,
      config: config,
      restaurant_on_off: "0",
      is_confirm: ''
    };
  },
  created() {
    this.getRestaurantById();
  },
   methods: {
    getRestaurantById() {
      vendorService
        .getRestaurantById({ restaurant_id: this.$route.params.restaurant_id })
        .then((response) => {
          const {
            name,
            restaurant_id,
            is_confirm,
            delivery_type_time_slots,
            restaurant_on_off
          } = response.data.result;
          this.restaurant_id = restaurant_id;
          this.restaurant_on_off = restaurant_on_off;
          this.is_confirm = is_confirm;
          this.restaurant = {
            ...response.data.result,
            name,
            restaurant_id,
            is_confirm,
            delivery_type_time_slots
          };
        });
    },
  }
};
</script>